import { render, staticRenderFns } from "./AptListManage.vue?vue&type=template&id=2962039e&scoped=true"
import script from "./AptListManage.vue?vue&type=script&lang=js"
export * from "./AptListManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2962039e",
  null
  
)

export default component.exports